<template>
    <Page v-if="document.type === 'page'" :document="document" />
    <Post v-else-if="document.type === 'post'" :document="document" />
    <Lender v-else-if="document.type === 'lender'" :document="document" />
    <Author v-else-if="document.type === 'author'" :document="document" />
    <LenderCorporate v-else-if="document.type === 'lender_corporate'" :document="document" />
    <QuestionAnswer v-else-if="document.type === 'question_answer'" :document="document" />
</template>
<script>

import getDocument from '@/plugins/get-document';
import Page from '@/components/pages/Page.vue';
import Post from '@/components/pages/post/Post.vue';
import Lender from '@/components/pages/lender/Lender.vue';
import Author from '@/components/pages/Author.vue';
import LenderCorporate from '@/components/pages/lender-corporate/LenderCorporate.vue';
import QuestionAnswer from '@/components/pages/question-answer/QuestionAnswer.vue';

export default {
    components: {
        Page,
        Post,
        Lender,
        LenderCorporate,
        Author,
        QuestionAnswer
    },
    layout: 'site',

    async asyncData({$prismic, route, error}) {
        try {
            return await getDocument($prismic, route.path, error);
        }
        catch (e) {
            error({statusCode: 404, message: 'Not found'});
        }
    },
    computed: {
        settings() {
            return this.$store.state.settings;
        },
        seoTitle() {

            const seoTitle = this.trim(this.document.data.seo_title);
            if (seoTitle) {
                return seoTitle;
            }

            if (this.document.type === 'lender') {
                const template = this.trim(this.settings.lender_seo_title_template);
                if (template) {
                    return this.replaceLenderShortcodes(template);
                }
            }

            return '';
        },
        seoDescription() {
            const seoDescription = this.trim(this.document.data.seo_description);
            if (seoDescription) {
                return seoDescription;
            }

            if (this.document.type === 'lender') {
                const template = this.trim(this.settings.lender_seo_description_template);
                if (template) {
                    return this.replaceLenderShortcodes(template);
                }
            }

            return '';
        }
    },
    methods: {
        trim(template) {
            return (template || '')
                .trim();
        },
        replaceLenderShortcodes(template) {
            const model = new this.$models.Loan(this.document);
            return template
                .replaceAll('{title}', this.document.data.title)
                .replaceAll('{amount}', model.amountString)
                .replaceAll('{maxAmount}', model.maxAmountString)
                .replaceAll('{minAmount}', model.minAmountString)
                .replaceAll('{interest}', model.interestString)
                .replaceAll('{minInterest}', model.minInterestPossibleString)
                .replaceAll('{maxInterest}', model.maxInterestPossibleString)
                .replaceAll('{effectiveInterest}', model.effectiveInterestString)
                .replaceAll('{minEffectiveInterest}', model.minEffectiveInterestPossibleString)
                .replaceAll('{maxEffectiveInterest}', model.maxEffectiveInterestPossibleString)
                .replaceAll('{duration}', model.getDurationString(this.$translate('month_short', 'mån'), this.$translate('year', 'år')))
                .replaceAll('{creditCheck}', this.$getCreditCheckString(model.creditCheck));
        }
    },
    head() {
        return {
            htmlAttrs: {
                lang: this.document.data.is_english_page ? 'en' : process.env.HTML_LANG || undefined
            },
            title: this.seoTitle,
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: this.seoDescription
                }
            ]
                .concat(this.document.data.is_landing_page === true ? [{ name: 'robots', content: 'noindex' }] : []),
            link: [
                {
                    rel: 'canonical',
                    href: this.$prismic.linkResolver(this.document, true)
                },
            ]
                .concat(this.hreflangs)
        };
    }
};
</script>
